import { ReactNode } from 'react';
import OrFooterArea from '../organisms/OrFooterArea';
import OrHeaderAreaNoLogin from '../organisms/OrHeaderAreaNoLogin';

/** 属性定義 */
type Props = {
  children: ReactNode;
};
const TemplateNoLogin = ({
  children
}: Props) => {
  return <div className='container'>
      <OrHeaderAreaNoLogin className='templateheader' />
      <div className='content'>{children}</div>
      <OrFooterArea className='templatefooter' />
    </div>;
};
export default TemplateNoLogin;